/**
 * Route Guard Configuration
 */

import { createRouter, createWebHistory } from 'vue-router';
import { isAuthenticated } from '../utils/auth';

// Import components
import DiffCheck from '../components/diffCheck/DiffCheck.vue';
import EncodeDecode from '../components/EncodeDecode/EncodeDecode.vue';
import ImageX from '../components/ImageX/Image.vue';
import MarkdownToPdf from '../components/ImageX/MarkdownToPdf.vue';
import IpDetect from '../components/ipDetect.vue';
import JsonFormatter from '../components/JsonEncoder/JsonFormatter.vue';
import Postman from '../components/postMan.vue';
import TimerBoy from '../components/timerBoy.vue';
import UserLogin from '../components/userLogin.vue';
import WoodenFish from '../components/games/woodenFish.vue';
import TopNews from '../components/topNews/TopNews.vue';
const StrategyHub = () => import('../components/strategyHub/StrategyHub.vue');
import WikiHome from '../components/wiki/WikiHome.vue';
import WhiteBoard from '../components/WhiteBoard/WhiteBoard.vue';
const BookShelf = () => import('../components/Books/BookShelf.vue');

// Route configuration
const routes = [
    { path: '/', component: JsonFormatter },
    { path: '/markdown', component: MarkdownToPdf },
    { path: '/json', component: JsonFormatter },
    { path: '/postman', component: Postman },
    { path: '/woodenFish', component: WoodenFish },
    { path: '/ipDetect', component: IpDetect },
    {
        path: '/encode',
        component: EncodeDecode,
        children: [
            { path: '', redirect: '/encode/base64' },
            { path: 'base64', component: () => import('../components/EncodeDecode/Base64Encoder.vue') },
            { path: 'md5', component: () => import('../components/EncodeDecode/Md5Encoder.vue') },
            { path: 'url', component: () => import('../components/EncodeDecode/UrlEncoder.vue') },
            { path: 'html', component: () => import('../components/EncodeDecode/HtmlEncoder.vue') },
        ],
    },
    {
        path: '/diffCheck',
        component: DiffCheck,
        children: [
            { path: '', redirect: '/diffCheck/textDiff' },
            { path: 'textDiff', component: () => import('../components/diffCheck/CodeDiff.vue') },
        ],
    },
    {
        path: '/image',
        component: ImageX,
        children: [
            { path: '', redirect: '/image/resize' },
            { path: 'resize', component: () => import('../components/ImageX/ImageResize.vue') },
            { path: 'removeBg', component: () => import('../components/ImageX/ImageRemoveBg.vue') },
            { path: 'colorPick', component: () => import('../components/ImageX/ColorPick.vue') },
        ],
    },
    { path: '/userLogin', component: UserLogin, meta: { guest: true } },
    { path: '/timerBoy', component: TimerBoy },
    { path: '/topNews', component: TopNews },
    { path: '/strategyHub', name: 'strategy-hub', component: StrategyHub },
    { path: '/whiteboard', component: WhiteBoard },
    { path: '/books', component: BookShelf },
    {
        path: '/wiki',
        component: WikiHome,
        children: [
            { path: '', name: 'wiki-list' },
            { path: 'word', name: 'wiki-word', component: () => import('../components/wiki/WordLookup.vue') },
            { path: 'new', name: 'wiki-new', component: () => import('../components/wiki/WikiEditor.vue') },
            { path: ':id', name: 'wiki-view', component: () => import('../components/wiki/WikiViewer.vue') },
            { path: ':id/edit', name: 'wiki-edit', component: () => import('../components/wiki/WikiEditor.vue') },
        ]
    },
];

// Create router instance
const router = createRouter({
    history: createWebHistory(),
    routes
});

// Routes that require authentication
const protectedRoutes = ['/wiki', '/strategyHub', '/books'];

/**
 * Setup route guards
 */
export function setupRouterGuards() {
    router.beforeEach(async (to, from, next) => {
        // Check if route requires authentication
        if (protectedRoutes.some(p => to.path.startsWith(p))) {
            if (!isAuthenticated()) {
                next('/userLogin');
                return;
            }
        }

        // If on login page and already authenticated, redirect to home
        if (to.path === '/userLogin' && isAuthenticated()) {
            next('/');
            return;
        }

        next();
    });
}

export default router;
